/**
 * Presentation Layer - Redux Provider
 * Wraps the application with Redux store
 */

"use client";

import { Provider } from "react-redux";
import { store } from "@/shared/domain/store";
import { type PropsWithChildren } from "react";

export function ReduxProvider({ children }: PropsWithChildren) {
  return <Provider store={store}>{children}</Provider>;
}
